import { render, staticRenderFns } from "./EditStaffColorModal.vue?vue&type=template&id=76141a72&"
import script from "./EditStaffColorModal.vue?vue&type=script&lang=js&"
export * from "./EditStaffColorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76141a72')) {
      api.createRecord('76141a72', component.options)
    } else {
      api.reload('76141a72', component.options)
    }
    module.hot.accept("./EditStaffColorModal.vue?vue&type=template&id=76141a72&", function () {
      api.rerender('76141a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffCalendar/EditStaffColorModal.vue"
export default component.exports